// extracted by mini-css-extract-plugin
export default {"wrapper":"Gv-z","addressLine":"Hv-z","fullName":"Iv-z"};